import React from 'react';
import MediaItemCard from './components/MediaItemCard';

function App() {
  return (
    <div style={{ padding: '2rem' }}>
      <h1>Chronoflix</h1>
      <p>Track your movie, TV, and anime time.</p>
      <MediaItemCard />
    </div>
  );
}

export default App;